export const TOKEN = 'Token'
